<div class="b-dashboard-insights__container">
  <div class="b-dashboard-insights__back-button">
    <a (click)="back()">
      <img src="/assets/images/dashboard/insights/back-arrow.svg" alt="">
      <span>Brain Research</span>
    </a>
  </div>

  <div class="research-tab research-tab__container">
    @if ((loaded$ | async) && form) {
      <div class="research-tab__global-text">
        <h4 class="research-tab__header">Brain Research</h4>
      </div>
      <form [formGroup]="form">
        <div class="d-flex flex-column flex-lg-row">
          <div class="flex-1">
            <div class="research-tab__image">
              @if (isDone$ | async) {
                <img @fadeIn src="/assets/images/dashboard/explore_card_done.svg" alt="">
              } @else {
                <img @fadeIn src="/assets/images/dashboard/more-research-main.webp" alt="">
              }
            </div>
          </div>
          <div class="flex-1">
            <mat-tab-group class="mat-tab-group__invisible-header" [selectedIndex]="step$ | async" dynamicHeight disableRipple>
              @for (confLine of formConfig; track confLine; let tabStep = $index) {
                <mat-tab>
                  <div class="tab-content-wrapper">
                    <div>
                      <h5 class="research-tab__subheader">{{ confLine.question }}</h5>
                      @if (confLine.subquestion) {
                        <h2 class="research-tab__subquestion">{{ confLine.subquestion }}</h2>
                      }
                      @if (confLine.type === 'slider') {
                        <mat-slider class="slider mat-slider__brainkey"
                          [formControlName]="confLine.name" thumbLabel tickInterval="1" [min]="confLine.range[0]"
                          [max]="confLine.range[1]" [step]="confLine.range[2]" displayValue="3"
                        ></mat-slider>
                      }
                    </div>
                    <div>
                      @if (confLine.type === 'radio') {
                        <div class="radio-button-section__group">
                          @for (choice of confLine.choices; track choice; let i = $index) {
                            <div class="radio-button-section__button-wrapper">
                              <input type="radio" class="radio-button-section__input"
                                [id]="getRadioButtonId(confLine.name, choice)" [value]="choice"
                                [formControlName]="confLine.name" />
                              <label class="next-button radio-button-section__button" [for]="getRadioButtonId(confLine.name, choice)" (click)="next()">
                                {{ getChoicesText(confLine, i) }}
                              </label>
                            </div>
                          }
                        </div>
                      }
                      @if (confLine.type === 'checkbox') {
                        <div class="checkbox-list" [formGroup]="getCheckboxFormGroup(confLine.name)">
                          @for (choice of confLine.choices; track choice) {
                            <mat-checkbox class="research-tab__checkbox" [formControlName]="choice">
                              {{ choice }}
                            </mat-checkbox>
                          }
                        </div>
                      }
                      @if (hasNextButton(tabStep)) {
                        <div class="next-button" (click)="next(true)">Next</div>
                      }
                      @if ((isDone$ | async) === false) {
                        <div class="skip-button">
                          <span (click)="skip()">Skip</span>
                        </div>
                      }
                    </div>
                  </div>
                </mat-tab>
              }
              <mat-tab>
                <div class="tab-content-wrapper">
                  <h5 class="research-tab__subheader">All done for now!</h5>
                  <p class="research-tab__text">
                    Thanks for answering all of your research questions! We’ll let you know when there are new ones.
                  </p>
                  <p class="research-tab__text">
                    You can find and update any of your answers
                    <span (click)="rewind()" class="research-tab__text-link">here</span>.
                  </p>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </form>
    }
  </div>

</div>
